"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  primary: {
    input: {
      border: '1px solid',
      borderColor: 'slategrey',
      borderRadius: 0,
      width: '100%',
      py: '3',
      px: '4',
      fontSize: '4',
      color: 'black',
      lineHeight: 'inherit',
      '::placeholder': {
        color: 'browngrey'
      },
      '&:focus': {
        borderColor: 'orange',
        outline: 'none',
        '::placeholder': {
          color: 'transparent'
        }
      }
    },
    password: {
      toggle: {}
    },
    select: {
      // pr: '44px',
      openIcon: {// right: '16px',
      }
    },
    multiselect: {},
    label: {},
    error: {},
    group: {
      inline: {
        items: {}
      },
      stacked: {
        items: {}
      }
    },
    hint: {},
    textarea: {},
    radio: {
      '&:focus': {},
      '&:checked': {}
    },
    slider: {},
    checkbox: {
      '&:checked': {},
      '&:focus + label': {}
    },
    toggle: {},
    summary: {
      root: {
        backgroundColor: '#ececec'
      },
      errorLink: {},
      errorList: {
        marginBottom: 0
      },
      errorItem: {
        margin: 0
      },
      heading: {
        fontSize: '7'
      }
    }
  }
};
exports.default = _default;